var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 120,
    viewBox: "0 0 240 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.324 5L120.164 5.02516L118.324 5.05032V5Z",
    fill: "#FCDFE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.458 5.05034L117.19 5.0755L116.458 5.10066V5.05034Z",
    fill: "#FCDFE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.5 5.05034L122.583 5.0755L121.5 5.10066V5.05034Z",
    fill: "#FCDFE8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.299 5.10061L115.829 5.12577L115.299 5.15093V5.10061Z",
    fill: "#FCDFE8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.113 5.10061L123.541 5.12577L123.113 5.15093V5.10061Z",
    fill: "#FCDFE8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.442 5.15094L114.821 5.1761L114.442 5.20126V5.15094Z",
    fill: "#FCDFE8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.071 5.15094L124.5 5.1761L124.071 5.20126V5.15094Z",
    fill: "#FCDFE8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.686 5.20128L113.963 5.22728L113.686 5.25244V5.20128Z",
    fill: "#FCDFE8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.029 5.20128L125.356 5.22728L125.029 5.25244V5.20128Z",
    fill: "#FCDFE8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.98 5.25241L113.308 5.27757L112.98 5.30273V5.25241Z",
    fill: "#FCDFE8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M125.684 5.25241L125.961 5.27757L125.684 5.30273V5.25241Z",
    fill: "#FCDFE8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M112.375 5.30275L112.653 5.32791L112.375 5.35307V5.30275Z",
    fill: "#FCDFE8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.289 5.30275L126.566 5.32791L126.289 5.35307V5.30275Z",
    fill: "#FCDFE8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M111.821 5.35309L112.098 5.37825L111.821 5.40341V5.35309Z",
    fill: "#FCDFE8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M126.894 5.35309L127.121 5.37825L126.894 5.40341V5.35309Z",
    fill: "#FCDFE8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.317 5.40343L111.543 5.42859L111.317 5.45375V5.40343Z",
    fill: "#FCDFE8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M127.448 5.40343L127.726 5.42859L127.448 5.45375V5.40343Z",
    fill: "#FCDFE8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.813 5.45376L111.039 5.47892L110.813 5.50408V5.45376Z",
    fill: "#FCDFE8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M128.003 5.45376L128.23 5.47892L128.003 5.50408V5.45376Z",
    fill: "#FCDFE8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M110.359 5.5041L110.585 5.52926L110.359 5.55442V5.5041Z",
    fill: "#FCDFE8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M128.457 5.5041L128.634 5.52933L128.457 5.55456V5.5041Z",
    fill: "#FCDFE8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M109.905 5.55444L110.132 5.5796L109.905 5.60476V5.55444Z",
    fill: "#FCDFE8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M128.86 5.55444L129.087 5.5796L128.86 5.60476V5.55444Z",
    fill: "#FCDFE8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M109.502 5.60465L109.678 5.62988L109.502 5.65511V5.60465Z",
    fill: "#FCDFE8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M129.314 5.60465L129.49 5.62988L129.314 5.65511V5.60465Z",
    fill: "#FCDFE8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M109.098 5.65498L109.275 5.68106L109.098 5.70629V5.65498Z",
    fill: "#FCDFE8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M129.717 5.65498L129.944 5.68098L129.717 5.70614V5.65498Z",
    fill: "#FCDFE8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M108.745 5.70611L108.872 5.73134L108.745 5.75657V5.70611Z",
    fill: "#FCDFE8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M130.171 5.70611L130.347 5.73134L130.171 5.75657V5.70611Z",
    fill: "#FCDFE8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M108.342 5.75645L108.519 5.78168L108.342 5.80691V5.75645Z",
    fill: "#FCDFE8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M130.574 5.75645L130.751 5.78168L130.574 5.80691V5.75645Z",
    fill: "#FCDFE8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M108.04 5.80679L108.166 5.83202L108.04 5.85725V5.80679Z",
    fill: "#FCDFE8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M130.927 5.80679L131.053 5.83202L130.927 5.85725V5.80679Z",
    fill: "#FCDFE8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M107.687 5.85713L107.813 5.88236L107.687 5.90759V5.85713Z",
    fill: "#FCDFE8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M131.28 5.85713L131.407 5.88236L131.28 5.90759V5.85713Z",
    fill: "#FCDFE8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M107.384 5.90747L107.511 5.9327L107.384 5.95793V5.90747Z",
    fill: "#FCDFE8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M131.582 5.90747L131.759 5.9327L131.582 5.95793V5.90747Z",
    fill: "#FCDFE8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M107.032 5.9578L107.158 5.98303L107.032 6.00827V5.9578Z",
    fill: "#FCDFE8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M131.935 5.9578L132.061 5.98303L131.935 6.00827V5.9578Z",
    fill: "#FCDFE8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M106.729 6.00814L106.855 6.03337L106.729 6.0586V6.00814Z",
    fill: "#FCDFE8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M132.288 6.00814L132.415 6.03337L132.288 6.0586V6.00814Z",
    fill: "#FCDFE8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M106.376 6.05848L106.502 6.08371L106.376 6.10894V6.05848Z",
    fill: "#FCDFE8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M132.59 6.05848L132.768 6.08371L132.59 6.10894V6.05848Z",
    fill: "#FCDFE8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M106.074 6.10869L106.2 6.13476L106.074 6.15999V6.10869Z",
    fill: "#FCDFE8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M132.943 6.10869L133.07 6.13476L132.943 6.15999V6.10869Z",
    fill: "#FCDFE8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M133.548 6.21028L133.674 6.23552L133.548 6.26075V6.21028Z",
    fill: "#FCDFE8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M105.217 6.26049L105.343 6.28572L105.217 6.31095V6.26049Z",
    fill: "#FCDFE8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M133.801 6.26049L133.927 6.28572L133.801 6.31095V6.26049Z",
    fill: "#FCDFE8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M134.102 6.31083L134.229 6.33606L134.102 6.36129V6.31083Z",
    fill: "#FCDFE8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M104.662 6.36117L104.789 6.3864L104.662 6.41163V6.36117Z",
    fill: "#FCDFE8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M134.355 6.36117L134.481 6.3864L134.355 6.41163V6.36117Z",
    fill: "#FCDFE8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M104.41 6.41151L104.536 6.43674L104.41 6.46197V6.41151Z",
    fill: "#FCDFE8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M134.909 6.46184L135.035 6.48707L134.909 6.5123V6.46184Z",
    fill: "#FCDFE8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M103.856 6.51218L103.982 6.53741L103.856 6.56264V6.51218Z",
    fill: "#FCDFE8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M135.162 6.51218L135.288 6.53741L135.162 6.56264V6.51218Z",
    fill: "#FCDFE8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M135.464 6.56252L135.591 6.58775L135.464 6.61382V6.56252Z",
    fill: "#FCDFE8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M135.716 6.61365L135.842 6.63888L135.716 6.66411V6.61365Z",
    fill: "#FCDFE8"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M102.394 6.81487L102.52 6.8401L102.394 6.86533V6.81487Z",
    fill: "#FCDFE8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M136.674 6.81487L136.8 6.8401L136.674 6.86533V6.81487Z",
    fill: "#FCDFE8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M137.128 6.91555L137.254 6.94078L137.128 6.96601V6.91555Z",
    fill: "#FCDFE8"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M137.581 7.01622L137.708 7.04145L137.581 7.06752V7.01622Z",
    fill: "#FCDFE8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M101.234 7.06735L101.36 7.09258L101.234 7.11781V7.06735Z",
    fill: "#FCDFE8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M117.669 9.23453L121.021 9.25969L117.669 9.28485V9.23453Z",
    fill: "#FCDFE8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M116.105 9.28487L116.736 9.31003L116.105 9.33519V9.28487Z",
    fill: "#FCDFE8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M122.306 9.28487L122.836 9.31003L122.306 9.33519V9.28487Z",
    fill: "#FCDFE8"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M115.148 9.3352L115.526 9.3612L115.148 9.38636V9.3352Z",
    fill: "#FCDFE8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M123.315 9.3352L123.793 9.3612L123.315 9.38636V9.3352Z",
    fill: "#FCDFE8"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M114.291 9.3862L114.669 9.41136L114.291 9.43652V9.3862Z",
    fill: "#FCDFE8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M124.272 9.3862L124.701 9.41136L124.272 9.43652V9.3862Z",
    fill: "#FCDFE8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M113.585 9.43654L113.913 9.4617L113.585 9.48686V9.43654Z",
    fill: "#FCDFE8"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M125.13 9.43654L125.407 9.4617L125.13 9.48686V9.43654Z",
    fill: "#FCDFE8"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M112.929 9.48688L113.207 9.51204L112.929 9.5372V9.48688Z",
    fill: "#FCDFE8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M125.734 9.48688L126.012 9.51204L125.734 9.5372V9.48688Z",
    fill: "#FCDFE8"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M112.375 9.53721L112.652 9.56238L112.375 9.58754V9.53721Z",
    fill: "#FCDFE8"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M126.34 9.53721L126.566 9.56238L126.34 9.58754V9.53721Z",
    fill: "#FCDFE8"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M111.871 9.58755L112.098 9.61271L111.871 9.63788V9.58755Z",
    fill: "#FCDFE8"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M126.894 9.58755L127.171 9.61271L126.894 9.63788V9.58755Z",
    fill: "#FCDFE8"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M111.367 9.63789L111.543 9.66312L111.367 9.68835V9.63789Z",
    fill: "#FCDFE8"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M127.499 9.63789L127.675 9.66312L127.499 9.68835V9.63789Z",
    fill: "#FCDFE8"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M110.913 9.68823L111.09 9.71346L110.913 9.73869V9.68823Z",
    fill: "#FCDFE8"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M127.953 9.68823L128.129 9.71346L127.953 9.73869V9.68823Z",
    fill: "#FCDFE8"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M110.459 9.73857L110.636 9.7638L110.459 9.78903V9.73857Z",
    fill: "#FCDFE8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M128.356 9.73857L128.533 9.7638L128.356 9.78903V9.73857Z",
    fill: "#FCDFE8"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M110.056 9.78878L110.233 9.81485L110.056 9.84008V9.78878Z",
    fill: "#FCDFE8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M128.81 9.78878L128.986 9.81485L128.81 9.84008V9.78878Z",
    fill: "#FCDFE8"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M109.653 9.84003L109.83 9.86527L109.653 9.8905V9.84003Z",
    fill: "#FCDFE8"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M129.213 9.84003L129.39 9.86527L129.213 9.8905V9.84003Z",
    fill: "#FCDFE8"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M109.249 9.89037L109.427 9.9156L109.249 9.94083V9.89037Z",
    fill: "#FCDFE8"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M129.667 9.89037L129.843 9.9156L129.667 9.94083V9.89037Z",
    fill: "#FCDFE8"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M108.897 9.94071L109.023 9.96594L108.897 9.99117V9.94071Z",
    fill: "#FCDFE8"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M130.07 9.94071L130.196 9.96594L130.07 9.99117V9.94071Z",
    fill: "#FCDFE8"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M108.544 9.99105L108.67 10.0163L108.544 10.0415V9.99105Z",
    fill: "#FCDFE8"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M130.422 9.99105L130.549 10.0163L130.422 10.0415V9.99105Z",
    fill: "#FCDFE8"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M108.241 10.0413L108.367 10.0665L108.241 10.0917V10.0413Z",
    fill: "#FCDFE8"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M130.725 10.0413L130.902 10.0665L130.725 10.0917V10.0413Z",
    fill: "#FCDFE8"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M107.888 10.0916L108.015 10.1168L107.888 10.1421V10.0916Z",
    fill: "#FCDFE8"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M131.078 10.0916L131.204 10.1168L131.078 10.1421V10.0916Z",
    fill: "#FCDFE8"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M107.586 10.1419L107.712 10.1672L107.586 10.1924V10.1419Z",
    fill: "#FCDFE8"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M131.381 10.1419L131.558 10.1672L131.381 10.1924V10.1419Z",
    fill: "#FCDFE8"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M107.233 10.1923L107.41 10.2175L107.233 10.2427V10.1923Z",
    fill: "#FCDFE8"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M131.733 10.1923L131.86 10.2175L131.733 10.2427V10.1923Z",
    fill: "#FCDFE8"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M106.93 10.2426L107.057 10.2678L106.93 10.2939V10.2426Z",
    fill: "#FCDFE8"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M132.086 10.2426L132.212 10.2678L132.086 10.2939V10.2426Z",
    fill: "#FCDFE8"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M106.578 10.2937L106.755 10.319L106.578 10.3442V10.2937Z",
    fill: "#FCDFE8"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M132.389 10.2937L132.566 10.319L132.389 10.3442V10.2937Z",
    fill: "#FCDFE8"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M132.691 10.3441L132.818 10.3693L132.691 10.3945V10.3441Z",
    fill: "#FCDFE8"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M132.994 10.3944L133.12 10.4196L132.994 10.4449V10.3944Z",
    fill: "#FCDFE8"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M105.771 10.4448L105.897 10.47L105.771 10.4952V10.4448Z",
    fill: "#FCDFE8"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M133.246 10.4448L133.372 10.47L133.246 10.4952V10.4448Z",
    fill: "#FCDFE8"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M133.801 10.5453L133.927 10.5705L133.801 10.5958V10.5453Z",
    fill: "#FCDFE8"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M104.964 10.5956L105.091 10.6209L104.964 10.6461V10.5956Z",
    fill: "#FCDFE8"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M134.355 10.646L134.481 10.6712L134.355 10.6964V10.646Z",
    fill: "#FCDFE8"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M134.607 10.6963L134.734 10.7215L134.607 10.7476V10.6963Z",
    fill: "#FCDFE8"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M104.158 10.7474L104.285 10.7727L104.158 10.7979V10.7474Z",
    fill: "#FCDFE8"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M103.452 10.8985L103.578 10.9237L103.452 10.9489V10.8985Z",
    fill: "#FCDFE8"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M102.998 10.9991L103.125 11.0244L102.998 11.0496V10.9991Z",
    fill: "#FCDFE8"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M136.069 10.9991L136.195 11.0244L136.069 11.0496V10.9991Z",
    fill: "#FCDFE8"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M102.545 11.0997L102.671 11.1249L102.545 11.1501V11.0997Z",
    fill: "#FCDFE8"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M136.523 11.0997L136.649 11.1249L136.523 11.1501V11.0997Z",
    fill: "#FCDFE8"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2782 12.3602L88.3035 12.4864H88.253L88.2782 12.3602Z",
    fill: "#FCDFE8"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2278 12.965L88.253 13.2426H88.2026L88.2278 12.965Z",
    fill: "#FCDFE8"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2781 13.469L88.3033 13.6963H88.253L88.2781 13.469Z",
    fill: "#FCDFE8"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M156.032 13.5705L156.36 13.7466L156.285 13.7214L156.032 13.6208V13.5705Z",
    fill: "#FCDFE8"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M157.646 14.3764L157.822 14.5034L157.747 14.4782L157.646 14.3764Z",
    fill: "#FCDFE8"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M113.938 16.2415L114.367 16.2675L113.938 16.2927V16.2415Z",
    fill: "#FCDFE8"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M113.383 16.2928L113.51 16.318L113.383 16.3433V16.2928Z",
    fill: "#FCDFE8"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M114.795 16.2928L114.922 16.318L114.795 16.3433V16.2928Z",
    fill: "#FCDFE8"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M113.031 16.3431L113.157 16.3684L113.031 16.3936V16.3431Z",
    fill: "#FCDFE8"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M115.097 16.3431L115.223 16.3684L115.097 16.3936V16.3431Z",
    fill: "#FCDFE8"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M116.609 16.7968L116.787 16.923L116.711 16.8978L116.609 16.7968Z",
    fill: "#FCDFE8"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M120.038 20.6783L120.315 20.7034L120.038 20.7286V20.6783Z",
    fill: "#FCDFE8"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M120.492 20.6783L121.273 20.7034L120.492 20.7286V20.6783Z",
    fill: "#FCDFE8"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M122.155 20.7285L122.836 20.7537L122.155 20.7788V20.7285Z",
    fill: "#FCDFE8"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M123.264 20.7788L123.592 20.804L123.264 20.8292V20.7788Z",
    fill: "#FCDFE8"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M124.021 20.8292L124.398 20.8543L124.021 20.8803V20.8292Z",
    fill: "#FCDFE8"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M124.776 20.8803L125.155 20.9055L124.776 20.9306V20.8803Z",
    fill: "#FCDFE8"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M125.432 20.9306L125.609 20.9559L125.432 20.9811V20.9306Z",
    fill: "#FCDFE8"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M125.886 20.981L126.112 21.0061L125.886 21.0313V20.981Z",
    fill: "#FCDFE8"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M126.39 21.0313L126.617 21.0565L126.39 21.0816V21.0313Z",
    fill: "#FCDFE8"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M126.894 21.0817L127.071 21.1069L126.894 21.1321V21.0817Z",
    fill: "#FCDFE8"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M127.348 21.132L127.574 21.1572L127.348 21.1823V21.132Z",
    fill: "#FCDFE8"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M127.751 21.1823L127.928 21.2076L127.751 21.2328V21.1823Z",
    fill: "#FCDFE8"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M128.154 21.2325L128.281 21.2578L128.154 21.283V21.2325Z",
    fill: "#FCDFE8"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M128.507 21.2829L128.634 21.3081L128.507 21.3342V21.2829Z",
    fill: "#FCDFE8"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M128.86 21.334L129.037 21.3592L128.86 21.3845V21.334Z",
    fill: "#FCDFE8"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M108.191 21.3843L108.216 21.5105H108.166L108.191 21.3843Z",
    fill: "#FCDFE8"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M129.213 21.3843L129.39 21.4096L129.213 21.4348V21.3843Z",
    fill: "#FCDFE8"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M129.566 21.4347L129.743 21.4599L129.566 21.4851V21.4347Z",
    fill: "#FCDFE8"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M129.918 21.485L130.045 21.5103L129.918 21.5355V21.485Z",
    fill: "#FCDFE8"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M130.221 21.5354L130.347 21.5606L130.221 21.5858V21.5354Z",
    fill: "#FCDFE8"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M130.776 21.636L130.902 21.6613L130.776 21.6865V21.636Z",
    fill: "#FCDFE8"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M131.078 21.6864L131.204 21.7116L131.078 21.7368V21.6864Z",
    fill: "#FCDFE8"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M108.14 21.7366L108.166 21.8636H108.115L108.14 21.7366Z",
    fill: "#FCDFE8"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M131.633 21.7878L131.759 21.8131L131.633 21.8383V21.7878Z",
    fill: "#FCDFE8"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M131.935 21.838L132.061 21.8633L131.935 21.8885V21.838Z",
    fill: "#FCDFE8"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M132.439 21.9387L132.566 21.964L132.439 21.9892V21.9387Z",
    fill: "#FCDFE8"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M133.145 22.0897L133.272 22.115L133.145 22.1402V22.0897Z",
    fill: "#FCDFE8"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M108.09 22.1904L108.115 22.619H108.065L108.09 22.1904Z",
    fill: "#FCDFE8"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M133.851 22.2415L133.977 22.2668L133.851 22.292V22.2415Z",
    fill: "#FCDFE8"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M108.09 22.7456L108.115 23.1741H108.065L108.09 22.7456Z",
    fill: "#FCDFE8"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M108.14 23.5012L108.166 23.6282H108.115L108.14 23.5012Z",
    fill: "#FCDFE8"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M108.191 23.8543L108.216 23.9805H108.166L108.191 23.8543Z",
    fill: "#FCDFE8"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M120.038 24.8624L120.264 24.8876L120.038 24.9127V24.8624Z",
    fill: "#FCDFE8"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M121.046 24.9128L121.878 24.9379L121.046 24.9631V24.9128Z",
    fill: "#FCDFE8"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M122.609 24.9631L122.987 24.9883L122.609 25.0143V24.9631Z",
    fill: "#FCDFE8"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M123.365 25.0142L123.743 25.0394L123.365 25.0645V25.0142Z",
    fill: "#FCDFE8"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M124.121 25.0646L124.5 25.0897L124.121 25.1149V25.0646Z",
    fill: "#FCDFE8"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M124.877 25.1149L125.055 25.1401L124.877 25.1654V25.1149Z",
    fill: "#FCDFE8"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M125.331 25.1651L125.558 25.1903L125.331 25.2154V25.1651Z",
    fill: "#FCDFE8"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M125.835 25.2154L126.062 25.2406L125.835 25.2658V25.2154Z",
    fill: "#FCDFE8"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M126.34 25.2658L126.566 25.2909L126.34 25.3161V25.2658Z",
    fill: "#FCDFE8"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M126.793 25.3161L127.02 25.3413L126.793 25.3664V25.3161Z",
    fill: "#FCDFE8"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M127.247 25.3665L127.373 25.3917L127.247 25.4169V25.3665Z",
    fill: "#FCDFE8"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M127.6 25.4168L127.727 25.442L127.6 25.4681V25.4168Z",
    fill: "#FCDFE8"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M127.953 25.4679L128.129 25.4932L127.953 25.5184V25.4679Z",
    fill: "#FCDFE8"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M128.306 25.5183L128.482 25.5435L128.306 25.5687V25.5183Z",
    fill: "#FCDFE8"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M128.659 25.5686L128.835 25.5938L128.659 25.6191V25.5686Z",
    fill: "#FCDFE8"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M129.061 25.6189L129.188 25.6442L129.061 25.6694V25.6189Z",
    fill: "#FCDFE8"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M119.484 25.6691L119.509 25.7448L119.407 25.7953L119.484 25.6691Z",
    fill: "#FCDFE8"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M129.364 25.6691L129.49 25.6944L129.364 25.7196V25.6691Z",
    fill: "#FCDFE8"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M129.667 25.7195L129.793 25.7447L129.667 25.7699V25.7195Z",
    fill: "#FCDFE8"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M129.918 25.7698L130.045 25.7951L129.918 25.8203V25.7698Z",
    fill: "#FCDFE8"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M130.221 25.8202L130.347 25.8454L130.221 25.8706V25.8202Z",
    fill: "#FCDFE8"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M130.524 25.8705L130.65 25.8957L130.524 25.9218V25.8705Z",
    fill: "#FCDFE8"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M130.776 25.9216L130.902 25.9469L130.776 25.9721V25.9216Z",
    fill: "#FCDFE8"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M131.078 25.972L131.204 25.9972L131.078 26.0224V25.972Z",
    fill: "#FCDFE8"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M131.834 26.123L131.961 26.1482L131.834 26.1734V26.123Z",
    fill: "#FCDFE8"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M132.54 26.2739L132.666 26.2991L132.54 26.3243V26.2739Z",
    fill: "#FCDFE8"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M112.98 28.9962L113.107 29.0214L112.98 29.0467V28.9962Z",
    fill: "#FCDFE8"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M115.198 28.9962L115.325 29.0214L115.198 29.0467V28.9962Z",
    fill: "#FCDFE8"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M113.282 29.0465L113.409 29.0718L113.282 29.097V29.0465Z",
    fill: "#FCDFE8"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M114.896 29.0465L115.022 29.0718L114.896 29.097V29.0465Z",
    fill: "#FCDFE8"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M113.736 29.0969L114.568 29.122L113.736 29.148V29.0969Z",
    fill: "#FCDFE8"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M117.618 36.3564L118.601 36.3815L117.618 36.4067V36.3564Z",
    fill: "#FCDFE8"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M121.197 36.3564L121.828 36.3815L121.197 36.4067V36.3564Z",
    fill: "#FCDFE8"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M116.761 36.4067L117.14 36.4319L116.761 36.457V36.4067Z",
    fill: "#FCDFE8"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M122.407 36.4067L122.785 36.4319L122.407 36.457V36.4067Z",
    fill: "#FCDFE8"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M115.904 36.4571L116.282 36.4822L115.904 36.5082V36.4571Z",
    fill: "#FCDFE8"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M123.214 36.4571L123.491 36.4822L123.214 36.5082V36.4571Z",
    fill: "#FCDFE8"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M115.299 36.5082L115.526 36.5334L115.299 36.5585V36.5082Z",
    fill: "#FCDFE8"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M123.819 36.5082L124.046 36.5334L123.819 36.5585V36.5082Z",
    fill: "#FCDFE8"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M114.846 36.5585L115.022 36.5838L114.846 36.609V36.5585Z",
    fill: "#FCDFE8"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M124.373 36.5585L124.6 36.5837L124.373 36.6088V36.5585Z",
    fill: "#FCDFE8"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M114.341 36.6089L114.518 36.6341L114.341 36.6593V36.6089Z",
    fill: "#FCDFE8"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M124.877 36.6089L125.155 36.634L124.877 36.6592V36.6089Z",
    fill: "#FCDFE8"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M113.837 36.6592L114.014 36.6844L113.837 36.7097V36.6592Z",
    fill: "#FCDFE8"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M125.381 36.6592L125.559 36.6844L125.381 36.7097V36.6592Z",
    fill: "#FCDFE8"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M113.383 36.7095L113.56 36.7348L113.383 36.76V36.7095Z",
    fill: "#FCDFE8"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M125.785 36.7095L125.912 36.7348L125.785 36.76V36.7095Z",
    fill: "#FCDFE8"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M113.031 36.7599L113.207 36.7851L113.031 36.8103V36.7599Z",
    fill: "#FCDFE8"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M126.138 36.7599L126.314 36.7851L126.138 36.8103V36.7599Z",
    fill: "#FCDFE8"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M112.678 36.8101L112.854 36.8353L112.678 36.8605V36.8101Z",
    fill: "#FCDFE8"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M126.541 36.8101L126.718 36.8353L126.541 36.8605V36.8101Z",
    fill: "#FCDFE8"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M112.325 36.8604L112.501 36.8857L112.325 36.9109V36.8604Z",
    fill: "#FCDFE8"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M126.944 36.8604L127.071 36.8857L126.944 36.9109V36.8604Z",
    fill: "#FCDFE8"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M111.972 36.9108L112.149 36.936L111.972 36.9621V36.9108Z",
    fill: "#FCDFE8"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M127.247 36.9108L127.373 36.936L127.247 36.9621V36.9108Z",
    fill: "#FCDFE8"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M111.619 36.9619L111.745 36.9871L111.619 37.0124V36.9619Z",
    fill: "#FCDFE8"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M127.549 36.9619L127.675 36.9871L127.549 37.0124V36.9619Z",
    fill: "#FCDFE8"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M111.317 37.0122L111.443 37.0375L111.317 37.0627V37.0122Z",
    fill: "#FCDFE8"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M127.852 37.0122L127.978 37.0375L127.852 37.0627V37.0122Z",
    fill: "#FCDFE8"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M128.154 37.0626L128.281 37.0878L128.154 37.113V37.0626Z",
    fill: "#FCDFE8"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M110.762 37.1129L110.888 37.1381L110.762 37.1634V37.1129Z",
    fill: "#FCDFE8"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M128.457 37.1129L128.583 37.1381L128.457 37.1634V37.1129Z",
    fill: "#FCDFE8"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M128.759 37.1632L128.885 37.1885L128.759 37.2137V37.1632Z",
    fill: "#FCDFE8"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M110.207 37.2136L110.334 37.2388L110.207 37.264V37.2136Z",
    fill: "#FCDFE8"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M129.011 37.2136L129.138 37.2388L129.011 37.264V37.2136Z",
    fill: "#FCDFE8"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M109.955 37.2639L110.082 37.2892L109.955 37.3144V37.2639Z",
    fill: "#FCDFE8"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M129.263 37.2639L129.39 37.2892L129.263 37.3144V37.2639Z",
    fill: "#FCDFE8"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M109.401 37.3645L109.527 37.3897L109.401 37.4149V37.3645Z",
    fill: "#FCDFE8"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M108.947 37.4661L109.074 37.4913L108.947 37.5165V37.4661Z",
    fill: "#FCDFE8"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M130.474 37.5164L130.6 37.5416L130.474 37.5669V37.5164Z",
    fill: "#FCDFE8"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M107.838 37.7176L107.965 37.7429L107.838 37.7681V37.7176Z",
    fill: "#FCDFE8"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M119.181 40.5406L120.718 40.5658L119.181 40.591V40.5406Z",
    fill: "#FCDFE8"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M117.467 40.591L117.845 40.6161L117.467 40.6421V40.591Z",
    fill: "#FCDFE8"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M121.6 40.591L122.079 40.6161L121.6 40.6421V40.591Z",
    fill: "#FCDFE8"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M116.609 40.6421L116.988 40.6673L116.609 40.6924V40.6421Z",
    fill: "#FCDFE8"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M122.558 40.6421L122.886 40.6673L122.558 40.6924V40.6421Z",
    fill: "#FCDFE8"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M115.854 40.6925L116.131 40.7176L115.854 40.7428V40.6925Z",
    fill: "#FCDFE8"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M123.264 40.6925L123.491 40.7176L123.264 40.7428V40.6925Z",
    fill: "#FCDFE8"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M115.35 40.7428L115.576 40.7679L115.35 40.7931V40.7428Z",
    fill: "#FCDFE8"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M123.819 40.7428L124.046 40.7679L123.819 40.7931V40.7428Z",
    fill: "#FCDFE8"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M114.846 40.793L115.072 40.8182L114.846 40.8433V40.793Z",
    fill: "#FCDFE8"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M124.323 40.793L124.55 40.8182L124.323 40.8433V40.793Z",
    fill: "#FCDFE8"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M114.341 40.8433L114.568 40.8685L114.341 40.8937V40.8433Z",
    fill: "#FCDFE8"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M124.877 40.8433L125.055 40.8686L124.877 40.8938V40.8433Z",
    fill: "#FCDFE8"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M113.938 40.8937L114.064 40.9189L113.938 40.9441V40.8937Z",
    fill: "#FCDFE8"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M125.23 40.8937L125.408 40.9189L125.23 40.9441V40.8937Z",
    fill: "#FCDFE8"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M113.585 40.944L113.711 40.9692L113.585 40.9945V40.944Z",
    fill: "#FCDFE8"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M125.634 40.944L125.81 40.9692L125.634 40.9945V40.944Z",
    fill: "#FCDFE8"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M113.232 40.9943L113.358 41.0196L113.232 41.0448V40.9943Z",
    fill: "#FCDFE8"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M125.987 40.9943L126.163 41.0196L125.987 41.0448V40.9943Z",
    fill: "#FCDFE8"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M112.879 41.0447L113.006 41.0699L112.879 41.0951V41.0447Z",
    fill: "#FCDFE8"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M126.39 41.0447L126.567 41.0699L126.39 41.0951V41.0447Z",
    fill: "#FCDFE8"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M112.527 41.095L112.653 41.1211L112.527 41.1463V41.095Z",
    fill: "#FCDFE8"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M126.742 41.095L126.869 41.1211L126.742 41.1463V41.095Z",
    fill: "#FCDFE8"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M112.174 41.1462L112.3 41.1714L112.174 41.1966V41.1462Z",
    fill: "#FCDFE8"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M111.871 41.1965L111.997 41.2217L111.871 41.247V41.1965Z",
    fill: "#FCDFE8"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M127.297 41.1965L127.424 41.2217L127.297 41.247V41.1965Z",
    fill: "#FCDFE8"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M111.619 41.2467L111.745 41.2719L111.619 41.2972V41.2467Z",
    fill: "#FCDFE8"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M127.6 41.2467L127.727 41.2719L127.6 41.2972V41.2467Z",
    fill: "#FCDFE8"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M127.902 41.297L128.028 41.3223L127.902 41.3475V41.297Z",
    fill: "#FCDFE8"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M111.064 41.3474L111.191 41.3726L111.064 41.3978V41.3474Z",
    fill: "#FCDFE8"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M128.205 41.3474L128.331 41.3726L128.205 41.3978V41.3474Z",
    fill: "#FCDFE8"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M110.51 41.448L110.636 41.4733L110.51 41.4985V41.448Z",
    fill: "#FCDFE8"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M129.163 41.5487L129.289 41.5748L129.163 41.6V41.5487Z",
    fill: "#FCDFE8"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M129.868 41.7005L129.994 41.7258L129.868 41.751V41.7005Z",
    fill: "#FCDFE8"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M100.327 44.4732L100.453 44.4984L100.327 44.5237V44.4732Z",
    fill: "#FCDFE8"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M130.625 49.2619L130.851 49.2871L130.625 49.3123V49.2619Z",
    fill: "#FCDFE8"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M131.784 49.2619L132.011 49.2871L131.784 49.3123V49.2619Z",
    fill: "#FCDFE8"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M130.322 49.3123L130.448 49.3375L130.322 49.3627V49.3123Z",
    fill: "#FCDFE8"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M132.237 49.3123L132.364 49.3375L132.237 49.3627V49.3123Z",
    fill: "#FCDFE8"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M192.733 50.3716L192.959 50.8002H192.909L192.733 50.3716Z",
    fill: "#FCDFE8"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M188.902 52.1353L188.977 52.2623H188.927L188.902 52.1353Z",
    fill: "#FCDFE8"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M189.91 54.2026L189.986 54.3792H189.935L189.91 54.2026Z",
    fill: "#FCDFE8"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M137.279 54.5054L137.304 54.6316H137.254L137.279 54.5054Z",
    fill: "#FCDFE8"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M125.331 54.6564L125.356 54.7826H125.306L125.331 54.6564Z",
    fill: "#FCDFE8"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M137.329 54.8576L137.354 54.9846H137.304L137.329 54.8576Z",
    fill: "#FCDFE8"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M125.28 55.0094L125.306 55.3877H125.255L125.28 55.0094Z",
    fill: "#FCDFE8"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M137.38 55.5638L137.405 55.7903H137.354L137.38 55.5638Z",
    fill: "#FCDFE8"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M125.28 55.9672L125.306 56.3454H125.255L125.28 55.9672Z",
    fill: "#FCDFE8"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M137.329 56.3203L137.354 56.497H137.304L137.329 56.3203Z",
    fill: "#FCDFE8"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M125.331 56.5719L125.356 56.6981H125.306L125.331 56.5719Z",
    fill: "#FCDFE8"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M137.279 56.6726C137.272 56.8177 137.314 56.9099 137.405 56.9502L137.254 56.8495L137.279 56.6726Z",
    fill: "#FCDFE8"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M132.439 61.9663L132.566 61.9915L132.439 62.0167V61.9663Z",
    fill: "#FCDFE8"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M130.372 62.0166L130.499 62.0418L130.372 62.0671V62.0166Z",
    fill: "#FCDFE8"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M132.137 62.0166L132.263 62.0418L132.137 62.0671V62.0166Z",
    fill: "#FCDFE8"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M130.725 62.0669L131.053 62.0921L130.725 62.1173V62.0669Z",
    fill: "#FCDFE8"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M131.582 62.0669L131.961 62.0921L131.582 62.1173V62.0669Z",
    fill: "#FCDFE8"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M160.419 65.243L160.545 65.4196L160.444 65.3691L160.419 65.243Z",
    fill: "#FCDFE8"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M199.135 68.1665L199.16 68.2935H199.11L199.135 68.1665Z",
    fill: "#FCDFE8"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M194.951 68.8224L194.976 68.9485H194.926L194.951 68.8224Z",
    fill: "#FCDFE8"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M199.437 69.5278L199.462 69.6548H199.412L199.437 69.5278Z",
    fill: "#FCDFE8"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M195.152 69.6796L195.178 69.8057H195.127L195.152 69.6796Z",
    fill: "#FCDFE8"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M195.303 70.3345L195.329 70.4607H195.278L195.303 70.3345Z",
    fill: "#FCDFE8"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M199.639 70.4855L199.664 70.6125H199.614L199.639 70.4855Z",
    fill: "#FCDFE8"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M199.69 70.738L199.715 70.8642H199.664L199.69 70.738Z",
    fill: "#FCDFE8"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M199.79 71.2924L199.816 71.4185H199.765L199.79 71.2924Z",
    fill: "#FCDFE8"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M199.841 71.5447L199.866 71.6709H199.815L199.841 71.5447Z",
    fill: "#FCDFE8"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M195.606 71.897L195.631 72.024H195.581L195.606 71.897Z",
    fill: "#FCDFE8"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M199.942 72.0992L199.967 72.2254H199.916L199.942 72.0992Z",
    fill: "#FCDFE8"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M195.656 72.1494L195.682 72.2756H195.631L195.656 72.1494Z",
    fill: "#FCDFE8"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M199.992 72.3508L200.018 72.4778H199.967L199.992 72.3508Z",
    fill: "#FCDFE8"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M195.707 72.4019L195.732 72.5281H195.682L195.707 72.4019Z",
    fill: "#FCDFE8"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M195.757 72.6535L195.782 72.7796H195.732L195.757 72.6535Z",
    fill: "#FCDFE8"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M200.043 72.6535L200.068 72.7796H200.017L200.043 72.6535Z",
    fill: "#FCDFE8"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M195.808 72.906L195.833 73.0321H195.782L195.808 72.906Z",
    fill: "#FCDFE8"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M200.093 72.9563L200.118 73.0825H200.068L200.093 72.9563Z",
    fill: "#FCDFE8"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M151.445 73.0066L163.62 73.0318L151.445 73.057V73.0066Z",
    fill: "#FCDFE8"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M184.162 73.0066L185.751 73.0318L184.162 73.057V73.0066Z",
    fill: "#FCDFE8"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M186.078 73.0066L188.271 73.0318L186.078 73.057V73.0066Z",
    fill: "#FCDFE8"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M191.371 73.0066L192.001 73.0318L191.371 73.057V73.0066Z",
    fill: "#FCDFE8"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M200.143 73.2582L200.169 73.3852H200.118L200.143 73.2582Z",
    fill: "#FCDFE8"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M179.978 73.6114L180.003 73.7375H179.953L179.978 73.6114Z",
    fill: "#FCDFE8"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M200.194 73.6114L200.219 73.7375H200.168L200.194 73.6114Z",
    fill: "#FCDFE8"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M200.244 73.9141L200.269 74.0402H200.219L200.244 73.9141Z",
    fill: "#FCDFE8"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M200.294 74.2159L200.32 74.3429H200.269L200.294 74.2159Z",
    fill: "#FCDFE8"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M200.446 74.9725L200.471 75.5017H200.421L200.446 74.9725Z",
    fill: "#FCDFE8"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M168.585 75.0731L168.61 75.2001H168.559L168.585 75.0731Z",
    fill: "#FCDFE8"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M180.281 75.1235L180.306 75.2505H180.256L180.281 75.1235Z",
    fill: "#FCDFE8"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M168.585 75.2753L168.61 75.4014H168.559L168.585 75.2753Z",
    fill: "#FCDFE8"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M180.382 75.6283L180.407 75.7545H180.356L180.382 75.6283Z",
    fill: "#FCDFE8"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M180.432 75.9302L180.508 76.0564L180.407 76.0059L180.432 75.9302Z",
    fill: "#FCDFE8"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M198.479 77.392L198.606 77.4172L198.479 77.4425V77.392Z",
    fill: "#FCDFE8"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M111.266 88.231H137.682L137.808 88.3568L137.682 88.2814H111.266V88.231Z",
    fill: "#FCDFE8"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0114 89.4916L74.0367 89.6178H73.9862L74.0114 89.4916Z",
    fill: "#FCDFE8"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M169.694 89.4916L169.72 89.6178H169.669L169.694 89.4916Z",
    fill: "#FCDFE8"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M106.83 95.692L106.88 95.7423H136.573L136.649 95.7172L136.573 95.7927H106.88L106.83 95.692Z",
    fill: "#FCDFE8"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3846 96.3981L52.3341 96.5495L52.3089 96.4738L52.3846 96.3981Z",
    fill: "#FCDFE8"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M148.118 96.3981L148.067 96.5495L148.042 96.4738L148.118 96.3981Z",
    fill: "#FCDFE8"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M106.023 97.9605H135.767L135.792 98.036L135.716 98.0109H106.023L105.973 98.0612L106.023 97.9605Z",
    fill: "#FCDFE8"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M166.367 99.019L166.443 99.1964H166.392L166.367 99.019Z",
    fill: "#FCDFE8"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M137.783 104.917L137.859 105.043L137.758 104.993L137.783 104.917Z",
    fill: "#FCDFE8"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M91.101 105.977L91.1767 106.103H91.1263L91.101 105.977Z",
    fill: "#FCDFE8"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0252 113.739L39.1009 113.866L39 113.816L39.0252 113.739Z",
    fill: "#FCDFE8"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M134.759 113.739L134.834 113.866L134.733 113.816L134.759 113.739Z",
    fill: "#FCDFE8"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M113.585 16.2928H114.593L114.643 16.3431H115.022V29.0214C115.022 29.0549 114.946 29.0633 114.794 29.0466L114.744 29.0969H113.484L112.325 28.8453L111.216 28.3412C110.62 27.9949 110.108 27.5663 109.678 27.0555L109.073 26.2487L108.519 25.14L108.166 23.8292L108.115 22.7707L108.065 22.6693L108.115 22.619V21.9136L108.166 21.8636L108.216 21.3081L108.418 20.5524L108.77 19.6953C109.157 18.9388 109.652 18.2922 110.258 17.7546C110.712 17.3512 111.233 17.0149 111.82 16.7465L112.527 16.4941L113.585 16.2928Z",
    fill: "#B24387"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M131.028 49.2619H131.582L131.86 49.3123V62.0417L131.834 62.0668H131.431L131.229 62.1172L131.179 62.0668H130.574L130.02 61.9662L128.961 61.6131C128.208 61.2567 127.561 60.7946 127.02 60.2268C126.442 59.612 125.988 58.8723 125.659 58.0085L125.356 56.8998L125.255 55.4379L125.306 55.3877V54.8324L125.356 54.7826L125.407 54.2277L125.911 52.7659C126.304 51.9658 126.817 51.2857 127.448 50.7237C127.912 50.3145 128.45 49.9782 129.061 49.7157L130.171 49.3626L130.978 49.3123L131.028 49.2619Z",
    fill: "#B24387"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M118.173 5L118.299 5.02523L118.173 5.05046V5Z",
    fill: "#FFFEFE"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M120.189 5L120.366 5.02523L120.189 5.05046V5Z",
    fill: "#FFFEFE"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M122.104 9.28487L122.282 9.3101L122.104 9.33533V9.28487Z",
    fill: "#FFFEFE"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2278 12.7133L88.253 12.9397H88.2026L88.2278 12.7133Z",
    fill: "#FFFEFE"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M121.298 20.6783L121.425 20.7035L121.298 20.7288V20.6783Z",
    fill: "#FFFEFE"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M185.776 73.0066L186.053 73.0318L185.776 73.057V73.0066Z",
    fill: "#FFFEFE"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M188.296 73.0066L191.346 73.0318L188.296 73.057V73.0066Z",
    fill: "#FFFEFE"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M192.027 73.0066L195.782 73.0321L192.027 73.057V73.0066Z",
    fill: "#FFFEFE"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4428 95.692L63.803 95.7172L53.4428 95.7423V95.692Z",
    fill: "#FFFEFE"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5899 95.692L100.906 95.7172L83.5899 95.7423V95.692Z",
    fill: "#FFFEFE"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M149.126 95.692L166.443 95.7172L149.126 95.7423V95.692Z",
    fill: "#FFFEFE"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M171.509 95.692H180.028L180.104 95.7675L180.028 95.7423H171.509V95.692Z",
    fill: "#FFFEFE"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M188.902 95.692L196.639 95.7172L188.902 95.7423V95.692Z",
    fill: "#FFFEFE"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M103.301 105.321L133.12 105.346L103.301 105.371V105.321Z",
    fill: "#FFFEFE"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4994 105.371L90.7228 105.396L72.4993 105.421L72.4994 105.371Z",
    fill: "#FFFEFE"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M138.035 105.371L156.208 105.396L138.035 105.421V105.371Z",
    fill: "#FFFEFE"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7809 114.9L39.8319 114.95L64.1049 114.975L39.8319 115L39.7809 114.9Z",
    fill: "#FFFEFE"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0286 114.95L94.252 114.975L70.0285 115L70.0286 114.95Z",
    fill: "#FFFEFE"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M101.385 114.95L127.877 114.975L101.385 115L101.385 114.95Z",
    fill: "#FFFEFE"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M135.565 114.95L159.788 114.975L135.565 115V114.95Z",
    fill: "#FFFEFE"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M175.34 114.95L180.306 114.975L175.34 115V114.95Z",
    fill: "#FFFEFE"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M112.879 5.30282L113.031 5.30275L114.114 6.38632L116.837 9.25962L113.383 9.43659L113.333 9.48698L111.67 9.58755L111.619 9.63794L111.216 9.63787L111.166 9.68819H110.762L110.712 9.73858L109.149 9.89031L109.098 9.94063H108.796L108.745 9.99095H108.443L108.09 10.0917L107.787 10.0916L107.434 10.1923L106.225 10.344L104.864 10.646H104.611L101.738 11.3018L98.4362 7.84813L101.184 7.11764L105.973 6.15988H106.275L106.628 6.05847L106.93 6.0584L108.645 5.75647L109.804 5.65499L109.855 5.60467L112.224 5.40339L112.274 5.35314L112.829 5.35307L112.879 5.30282Z",
    fill: "#EF4871"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M115.022 16.3934C115.425 16.4034 115.761 16.4957 116.03 16.6701V28.7697L115.904 28.7949L115.299 28.9961H115.022V16.3934Z",
    fill: "#EF4871"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M119.382 36.3564L122.054 36.4067L122.104 36.457H122.962L123.012 36.5082H123.617L123.668 36.5585H124.172L124.726 36.6591L125.23 36.6593L125.634 36.7598L127.146 36.9108L127.448 37.0122L129.414 37.3142L129.667 37.4148L130.625 37.5666L132.086 37.97H132.288L134.405 38.5747L137.481 39.6331L139.346 40.3896C142.713 41.8447 145.805 43.5757 148.622 45.5818C151.253 47.437 153.665 49.5127 155.856 51.8082C158.44 54.4835 160.725 57.4575 162.712 60.7308C163.781 62.5189 164.755 64.4009 165.636 66.3768L167.047 69.9563L167.905 72.6786L167.728 72.5528L162.132 68.6203H162.006L161.401 67.1333L160.242 64.8144C159.405 63.2653 158.497 61.7859 157.519 60.3778C155.667 57.7099 153.576 55.2811 151.243 53.0939C147.855 49.8775 143.94 47.1887 139.497 45.0275L137.834 44.271L135.162 43.2126L131.633 42.1038L128.607 41.3977L126.591 41.0446L124.726 40.8433L124.676 40.793L122.206 40.5909L116.433 36.5333L116.559 36.457L119.332 36.4067L119.382 36.3564Z",
    fill: "#EF4871"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M115.702 36.5082L115.829 36.5334L115.702 36.5587V36.5082Z",
    fill: "#EF4871"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M118.122 40.5406L118.449 40.5658L118.122 40.591V40.5406Z",
    fill: "#EF4871"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M121.147 40.5406L121.475 40.5658L121.147 40.591V40.5406Z",
    fill: "#EF4871"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M161.477 41.1462L168.283 42.2046L168.711 42.6331C172.375 46.6999 175.533 51.2707 178.188 56.3455L178.113 56.3203L173.021 55.5135L172.946 55.5387C170.001 50.4672 166.481 45.9719 162.384 42.0536L161.477 41.1462Z",
    fill: "#EF4871"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M137.329 55.261L137.354 55.388H137.304L137.329 55.261Z",
    fill: "#EF4871"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M137.329 55.9672L137.354 56.0933H137.304L137.329 55.9672Z",
    fill: "#EF4871"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M163.645 72.9563L163.695 73.0066H166.418L166.77 73.1073H166.871L167.123 73.2079C167.173 73.124 167.224 73.1408 167.275 73.2582C167.503 73.3018 167.679 73.3949 167.804 73.5358L167.879 73.6616C167.957 73.6382 167.982 73.6633 167.955 73.7371L168.156 73.8889V74.0147C168.258 73.9745 168.291 74.0164 168.258 74.1405C168.409 74.3426 168.509 74.5942 168.56 74.897V75.6023C168.435 76.2179 168.158 76.68 167.728 76.9895L167.325 77.2411L166.569 77.4424H160.015V77.3921H166.19V73.057H163.695L163.645 72.9563Z",
    fill: "#EF4871"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M149.73 73.057L149.908 73.0822L149.73 73.1074V73.057Z",
    fill: "#EF4871"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M184.238 73.057H190.288V77.3921H184.238V73.057Z",
    fill: "#EF4871"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M149.126 73.2582L149.202 73.2834L149.075 73.36L149.126 73.2582Z",
    fill: "#EF4871"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M147.967 74.8718L147.992 74.9979H147.942L147.967 74.8718Z",
    fill: "#EF4871"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M147.967 75.4765L147.992 75.654H147.942L147.967 75.4765Z",
    fill: "#EF4871"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M135.766 6.66399L138.64 7.26867L139.043 7.41963L141.211 7.92368L144.588 8.93261L147.26 9.84005L152.453 11.9066C154.574 12.8442 156.623 13.8523 158.604 14.9317C166.088 19.042 172.666 24.0573 178.34 29.9792C184.268 36.0831 189.209 43.1741 193.161 51.2539C194.065 53.1225 194.906 55.0548 195.681 57.0508L196.69 59.7732L197.597 62.5458L198.404 65.3185L199.261 68.7973L199.311 69.251L199.715 70.9645V71.2169L199.967 72.3256L200.269 74.242H200.219C200.074 73.9158 199.864 73.6549 199.589 73.4604C199.313 73.3497 199.103 73.1727 198.958 72.9312L194.926 68.6958L194.119 65.4695L193.212 62.4955L192.203 59.6222L191.296 57.3033C189.763 53.6097 188.016 50.1309 186.053 46.8676C182.598 41.1143 178.54 35.9631 173.878 31.4158C169.204 26.7813 163.91 22.7657 157.998 19.3674L155.427 17.9559L150.588 15.637L145.748 13.7214L142.572 12.663L141.06 12.2596L140.783 11.982L135.766 6.66399Z",
    fill: "#F47F3F"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M98.411 7.82295L101.713 11.2766L96.9492 12.5615L94.1262 13.5201L90.9753 10.2677L91.4039 10.0412L94.3275 9.03316L98.411 7.82295Z",
    fill: "#EB3885"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3869 10.9488H89.8909L90.4461 11.1501C90.8655 11.3857 91.2269 11.6801 91.5297 12.0324C91.9935 12.5431 92.3633 13.1486 92.6384 13.8473L101.31 39.3061L101.663 40.1624L102.066 41.5747C102.016 41.7592 102.032 41.8767 102.116 41.927V42.9862L101.965 43.5909L101.637 44.1201L101.46 44.1956L101.486 44.2711L101.335 44.2208L100.805 44.4732L100.78 44.5738C100.69 44.4799 100.538 44.4464 100.327 44.4732L99.6204 44.1201L98.6878 43.2378C98.302 42.7506 97.9825 42.1962 97.73 41.5747L90.2692 19.645L88.908 15.814L88.4039 14.2507L88.3033 13.7466V13.3432L88.253 13.2929V12.6379L88.4039 11.9317C88.5147 11.6055 88.6916 11.3455 88.9332 11.1501L89.3869 10.9488Z",
    fill: "#EB3885"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M115.854 36.5082H116.408L116.509 36.5585L122.181 40.5657L121.5 40.5909L121.449 40.5405L118.122 40.5406L118.072 40.5909L116.307 40.642L116.257 40.6925L115.702 40.6923L115.652 40.7428L114.19 40.8433L114.14 40.8937L113.786 40.8936L113.736 40.9439L112.375 41.0949L111.216 41.3473H110.963L106.401 38.1461L109.351 37.4148H109.602L111.266 37.0626L113.282 36.8101L113.333 36.7598H113.686L113.736 36.7095H114.19L114.24 36.6591H114.694L115.248 36.5585H115.803L115.854 36.5082Z",
    fill: "#EB3885"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M136.119 51.8334L136.145 51.934C136.235 51.8971 136.269 51.9223 136.245 52.0095C136.625 52.5203 136.911 53.1258 137.102 53.8244L137.304 54.8325L137.354 55.9421L137.304 55.9924L137.253 56.925C140.198 58.6292 142.785 60.7041 145.017 63.1505L145.874 64.1091L145.799 64.0831L136.421 59.1433L135.968 59.7983L136.044 59.6725L136.094 59.5719L136.119 51.8334Z",
    fill: "#EB3885"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M172.996 55.5135L175.391 55.8666L175.441 55.9169H175.744L176.701 56.1182H177.004L177.659 56.2691H177.962L178.188 56.3958L180.256 60.7309L181.465 63.756L181.515 64.0328L178.819 63.6294L178.769 63.579H178.466L177.508 63.3778H177.206L176.852 63.2771L176.777 63.3023L176.374 62.243L175.365 60.0256L172.996 55.5135Z",
    fill: "#EB3885"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M162.082 68.6204L167.905 72.7291L168.258 73.9896L168.156 73.9393L167.728 73.4604C167.483 73.2683 167.18 73.1341 166.821 73.057C166.612 73.1174 166.478 73.1006 166.418 73.0066H163.695L163.62 72.9312L163.065 71.1666L162.082 68.6204Z",
    fill: "#EB3885"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M150.184 73.0066L151.42 73.0318L150.184 73.057V73.0066Z",
    fill: "#EB3885"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M182.55 73.0066H184.112L184.238 73.057V77.3921L182.146 77.3921L181.818 77.2663V73.2331L181.944 73.1073C181.995 73.1912 182.045 73.1744 182.096 73.057L182.398 73.1073L182.55 73.0066Z",
    fill: "#EB3885"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M154.495 73.057L166.19 73.057V77.3921H160.015L159.965 77.4424H149.933V77.3921H154.495V73.057Z",
    fill: "#EB3885"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M181.088 73.561L181.113 73.6617L180.961 73.7372L180.886 73.8638L180.86 73.7883L181.088 73.561Z",
    fill: "#EB3885"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M148.622 73.6114L148.697 73.6365L148.546 73.7372L148.521 73.8135L148.496 73.7372L148.622 73.6114Z",
    fill: "#EB3885"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M180.583 74.2159L180.609 74.2923L180.432 74.7208L180.407 74.5942L180.583 74.2159Z",
    fill: "#EB3885"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M180.382 74.7711L180.407 75.0479H180.356L180.382 74.7711Z",
    fill: "#EB3885"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M180.331 75.1235L180.357 75.3009H180.306L180.331 75.1235Z",
    fill: "#EB3885"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0573 88.3821L73.2297 88.4072L49.0573 88.4324V88.3821Z",
    fill: "#EB3885"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2539 88.3821L103.427 88.4072L79.2539 88.4324V88.3821Z",
    fill: "#EB3885"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M144.791 88.3821L168.913 88.4072L144.791 88.4324V88.3821Z",
    fill: "#EB3885"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M174.887 88.3821L199.11 88.4072L174.887 88.4324V88.3821Z",
    fill: "#EB3885"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7831 98.0109L100.1 98.036L82.7831 98.0612V98.0109Z",
    fill: "#EB3885"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M148.319 98.0109L165.586 98.036L148.319 98.0612V98.0109Z",
    fill: "#EB3885"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M102.545 107.539L132.212 107.564L102.545 107.589V107.539Z",
    fill: "#EB3885"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M49.309 107.64L59.6691 107.665L49.309 107.69V107.64Z",
    fill: "#EB3885"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5999 107.64L89.9161 107.665L72.5999 107.69V107.64Z",
    fill: "#EB3885"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M138.136 107.64L155.402 107.665L138.136 107.69V107.64Z",
    fill: "#EB3885"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M117.215 5.05034H121.449L121.5 5.10066H123.062L123.113 5.15093L125.634 5.25246L125.684 5.30273L127.952 5.45374L128.003 5.50408L128.406 5.50406L128.86 5.60476L130.524 5.7565L130.574 5.80691L132.54 6.05843L132.59 6.10894L133.246 6.15991L133.801 6.31095L134.607 6.41151L134.758 6.51215L134.859 6.46183L135.313 6.61363L135.413 6.56247L135.666 6.61363L136.548 7.49508L141.034 12.2344L140.959 12.2093L140.657 12.159L140.555 12.0575H140.455C140.314 12.0843 140.23 12.0508 140.203 11.9568H140.102L135.464 10.8481L133.901 10.5453H133.649L133.094 10.3944H132.843L132.54 10.2937L131.885 10.2426L131.834 10.1923L129.868 9.94066L129.818 9.89034H129.414L129.364 9.84002L128.557 9.78886L128.507 9.73854L127.701 9.68822L127.65 9.6379H127.196L127.146 9.58758H126.591L126.541 9.53726L125.432 9.48694L125.381 9.43662H124.726L124.676 9.3863H123.819L123.768 9.33514L121.046 9.28482L120.996 9.23449L117.669 9.23453L117.618 9.28482L116.862 9.28486L113.056 5.32794C113.281 5.23401 113.575 5.20801 113.938 5.25246L113.989 5.2013L115.803 5.15098L115.854 5.10066H117.165L117.215 5.05034Z",
    fill: "#F0665D"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M112.678 5.30275L112.854 5.32798L112.678 5.35321V5.30275Z",
    fill: "#F0665D"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M112.123 5.35309L112.25 5.37832L112.123 5.40355V5.35309Z",
    fill: "#F0665D"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M111.568 5.40343L111.746 5.42866L111.568 5.45389V5.40343Z",
    fill: "#F0665D"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M111.064 5.45376L111.191 5.47899L111.064 5.50422V5.45376Z",
    fill: "#F0665D"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M110.61 5.5041L110.737 5.52933L110.61 5.55456V5.5041Z",
    fill: "#F0665D"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M110.157 5.55444L110.284 5.57967L110.157 5.6049V5.55444Z",
    fill: "#F0665D"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M109.703 5.60465L109.83 5.62988L109.703 5.65511V5.60465Z",
    fill: "#F0665D"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M109.3 5.65498L109.427 5.68106L109.3 5.70629V5.65498Z",
    fill: "#F0665D"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M108.897 5.70611L109.023 5.73134L108.897 5.75657V5.70611Z",
    fill: "#F0665D"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M115.702 9.28487L116.08 9.31003L115.702 9.33519V9.28487Z",
    fill: "#F0665D"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M114.846 9.3352L115.122 9.3612L114.846 9.38636V9.3352Z",
    fill: "#F0665D"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M114.039 9.3862L114.265 9.41136L114.039 9.43652V9.3862Z",
    fill: "#F0665D"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M113.383 9.43659L113.56 9.46177L113.383 9.487L113.383 9.43659Z",
    fill: "#F0665D"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M112.778 9.48688L112.905 9.51211L112.778 9.53734V9.48688Z",
    fill: "#F0665D"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M112.224 9.53721L112.35 9.56245L112.224 9.58768V9.53721Z",
    fill: "#F0665D"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M111.67 9.58755L111.846 9.61278L111.67 9.63801L111.67 9.58755Z",
    fill: "#F0665D"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M111.216 9.63787L111.342 9.66312L111.216 9.68835L111.216 9.63787Z",
    fill: "#F0665D"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M110.762 9.68819L110.888 9.71346L110.762 9.73869L110.762 9.68819Z",
    fill: "#F0665D"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M110.308 9.73857L110.435 9.7638L110.308 9.78903V9.73857Z",
    fill: "#F0665D"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M109.905 9.78878L110.031 9.81485L109.905 9.84008V9.78878Z",
    fill: "#F0665D"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M116.005 16.5947C117.003 16.9411 117.818 17.4703 118.449 18.1832C119.109 18.8616 119.579 19.7104 119.861 20.7285L120.441 20.6782L120.492 20.7286L122.104 20.7285L122.155 20.7788L123.214 20.7789L123.264 20.8292L125.381 20.9307L125.432 20.9811L128.103 21.2326L128.154 21.283L129.868 21.485L131.633 21.8383L132.187 21.8884L136.926 22.9972L139.194 23.653L142.976 24.963L145.849 26.1229L147.865 27.0304L152.049 29.1983C153.884 30.2366 155.649 31.3453 157.343 32.5254C160.973 35.0624 164.292 37.9113 167.3 41.0698L168.56 42.431L168.283 42.2046L161.477 41.1462L161.88 41.6502L161.401 41.1713V41.095L161.124 40.944C159.679 39.5828 158.15 38.3055 156.536 37.1129C155.084 36.0268 153.572 35.002 151.999 34.0375C150.107 32.8718 148.124 31.7957 146.05 30.8111L142.068 29.0969L137.884 27.635L136.321 27.2316L135.968 27.0807L133.347 26.4257L132.893 26.3745L131.179 25.9719H130.927L129.163 25.6189L128.154 25.5182L128.103 25.4679H127.751L127.701 25.4167L126.591 25.3161L126.541 25.2658L125.079 25.1651L125.029 25.1148L123.012 25.0142L122.962 24.963L120.29 24.9127L120.239 24.8624H119.811C119.435 26.0223 118.821 26.9633 117.971 27.6854L116.963 28.3915L116.055 28.7949L116.03 16.6701L116.005 16.5947Z",
    fill: "#F0665D"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M118.626 36.3564L119.357 36.3815L118.626 36.4067V36.3564Z",
    fill: "#F0665D"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M120.643 36.3564L121.172 36.3815L120.643 36.4067V36.3564Z",
    fill: "#F0665D"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M117.165 36.4067L117.391 36.4319L117.165 36.457V36.4067Z",
    fill: "#F0665D"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M122.104 36.4067L122.382 36.4319L122.104 36.457L122.104 36.4067Z",
    fill: "#F0665D"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M116.308 36.4571L116.534 36.4822L116.308 36.5082V36.4571Z",
    fill: "#F0665D"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M123.012 36.4571L123.189 36.4823L123.012 36.5082L123.012 36.4571Z",
    fill: "#F0665D"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M115.551 36.5082L115.677 36.5334L115.551 36.5587V36.5082Z",
    fill: "#F0665D"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M123.668 36.5082L123.794 36.5334L123.668 36.5585L123.668 36.5082Z",
    fill: "#F0665D"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M115.047 36.5585L115.173 36.5838L115.047 36.609V36.5585Z",
    fill: "#F0665D"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M124.222 36.5585L124.348 36.5838L124.222 36.609V36.5585Z",
    fill: "#F0665D"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M114.543 36.6089L114.669 36.6341L114.543 36.6593V36.6089Z",
    fill: "#F0665D"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M124.726 36.6089L124.852 36.6341L124.726 36.6591L124.726 36.6089Z",
    fill: "#F0665D"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M114.039 36.6592L114.165 36.6844L114.039 36.7097V36.6592Z",
    fill: "#F0665D"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M125.634 36.7095L125.76 36.7348L125.634 36.7598V36.7095Z",
    fill: "#F0665D"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M126.793 36.8605L126.92 36.8857L126.793 36.9109L126.793 36.8605Z",
    fill: "#F0665D"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M118.475 40.5406L119.156 40.5658L118.475 40.591V40.5406Z",
    fill: "#F0665D"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M120.743 40.5406L121.121 40.5658L120.743 40.591V40.5406Z",
    fill: "#F0665D"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M117.265 40.591L117.442 40.6162L117.265 40.6423V40.591Z",
    fill: "#F0665D"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M122.104 40.591L122.332 40.6161L122.104 40.6421V40.591Z",
    fill: "#F0665D"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M116.408 40.6421L116.585 40.6673L116.408 40.6926V40.6421Z",
    fill: "#F0665D"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M122.911 40.6421L123.088 40.6673L122.911 40.6926V40.6421Z",
    fill: "#F0665D"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M123.516 40.6925L123.643 40.7177L123.516 40.7429V40.6925Z",
    fill: "#F0665D"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M124.071 40.7428L124.197 40.768L124.071 40.7932V40.7428Z",
    fill: "#F0665D"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M124.575 40.793L124.701 40.8182L124.575 40.8435V40.793Z",
    fill: "#F0665D"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M137.329 55.0094L137.354 55.2359H137.304L137.329 55.0094Z",
    fill: "#F0665D"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M137.329 56.1182L137.354 56.2957H137.304L137.329 56.1182Z",
    fill: "#F0665D"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M194.951 68.7218L199.387 73.3597C199.663 73.4704 199.872 73.6466 200.017 73.8889L200.194 74.1657L200.244 74.0651L200.269 74.1405L200.219 74.242L200.421 74.7964V75.6535C200.282 76.2381 200.006 76.6834 199.589 76.9895L198.933 77.3418L198.429 77.4424H182.297V77.3921H190.262L190.288 77.3669L190.288 73.057L195.808 73.057L195.833 72.9312L195.329 70.6122V70.3598L195.127 69.6544V69.553L194.951 68.7218Z",
    fill: "#F0665D"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M166.669 73.057L166.795 73.0822L166.669 73.1074V73.057Z",
    fill: "#F0665D"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M166.619 77.392L166.846 77.4172L166.619 77.4423V77.392Z",
    fill: "#F0665D"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M114.644 16.2928L114.77 16.318L114.643 16.3431L114.644 16.2928Z",
    fill: "#DD2B8D"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M130.876 49.2619L131.003 49.2872L130.876 49.3124V49.2619Z",
    fill: "#DD2B8D"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M131.633 49.2619L131.759 49.2872L131.633 49.3124V49.2619Z",
    fill: "#DD2B8D"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M131.86 49.3123L132.086 49.3626L132.187 49.3123L132.439 49.4137H132.54L132.641 49.4641H132.741L132.994 49.5647H133.094L133.448 49.6654L133.548 49.766H133.649L134.229 50.0184C134.189 50.1191 134.231 50.1526 134.355 50.1191C134.862 50.4353 135.308 50.8135 135.691 51.2538L136.094 51.8082L136.094 59.5719C135.855 59.9719 135.562 60.3158 135.212 60.6051L134.254 61.3104L133.548 61.6635H133.397L133.297 61.7641L132.793 61.8656L132.641 61.9662H132.54L132.389 62.0165H132.288L132.086 62.0669L131.986 62.0165L131.86 62.0669V49.3123Z",
    fill: "#DD2B8D"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M131.078 62.0669L131.204 62.0922L131.078 62.1174V62.0669Z",
    fill: "#DD2B8D"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M131.431 62.0668L131.558 62.0922L131.431 62.1174L131.431 62.0668Z",
    fill: "#DD2B8D"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M179.701 72.3005L183.986 72.9815L182.046 73.0569C181.517 73.2012 181.106 73.462 180.81 73.8386C180.524 74.1405 180.365 74.5691 180.331 75.1235L180.256 74.9976L180.155 74.242L179.701 72.3005Z",
    fill: "#DD2B8D"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M147.614 74.6697L147.941 74.8215L147.915 75.4765L147.614 74.6697Z",
    fill: "#DD2B8D"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8998 10.2426L91.9833 11.2767L94.1002 13.4942L92.7138 14.0242C92.3482 13.0463 91.8097 12.2395 91.1011 11.6038L90.2439 11.0494L89.8909 10.9488H89.3869L88.9332 11.1501L89.0849 10.9488L90.8998 10.2426Z",
    fill: "#ED2E8B"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M106.275 38.1713C106.453 38.1445 106.571 38.178 106.628 38.272L110.938 41.3222C110.958 41.4161 110.866 41.4413 110.661 41.3977L107.989 42.0024L105.922 42.6079L101.763 39.6583L103.754 38.9278L106.275 38.1713Z",
    fill: "#ED2E8B"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M102.091 41.7509L102.116 41.877H102.066L102.091 41.7509Z",
    fill: "#ED2E8B"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M102.141 42.2046L102.167 42.3307H102.116L102.141 42.2046Z",
    fill: "#ED2E8B"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M136.421 59.1433L145.799 64.0831L146.025 64.3105C147.743 66.3065 149.221 68.5416 150.462 71.0157L150.386 71.0408L143.127 67.2089L142.698 66.8307C142.06 66.0247 141.362 65.2766 140.606 64.5881C139.01 63.0583 137.237 61.7055 135.288 60.5297C135.751 60.1531 136.129 59.6909 136.421 59.1433Z",
    fill: "#ED2E8B"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M176.852 63.2771L177.206 63.3778H177.508L178.466 63.579H178.769L179.424 63.7309H179.726L179.777 63.7812L181.567 64.0328L182.928 68.2421L182.851 68.2681L181.239 67.9654H180.936L180.281 67.8144H179.978L179.02 67.6123L178.416 67.5619L178.34 67.4865C177.907 66.0548 177.403 64.6937 176.827 63.403L176.852 63.2771Z",
    fill: "#ED2E8B"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M150.083 73.057H154.495V77.3921H149.73C149.395 77.325 149.117 77.1992 148.899 77.0147V73.4855L148.975 73.4101L149.68 73.1073C149.892 73.1643 150.026 73.1476 150.083 73.057Z",
    fill: "#ED2E8B"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M181.743 73.2079L181.818 73.2331V77.2663L181.743 77.2411C181.433 77.1471 181.19 76.9878 181.011 76.7622V73.7371L181.239 73.5106L181.743 73.2079Z",
    fill: "#ED2E8B"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M101.738 39.6331C103.082 40.6789 104.469 41.6535 105.897 42.5576C105.941 42.6683 105.882 42.7018 105.721 42.6582C104 43.1891 102.37 43.8106 100.831 44.5234V44.4731L101.587 44.1703L101.763 43.9942L102.016 43.4902L102.116 43.0868C102.059 42.7236 102.076 42.4376 102.167 42.2297L102.116 42.1793V41.7759L102.016 41.4732V41.2216L101.512 39.7598L101.738 39.6331Z",
    fill: "#ED2E8C"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M142.925 67.0579L150.286 70.9393L150.512 71.1163L151.369 73.0066H150.184L149.983 73.1073L149.655 73.057L149.63 73.1576L149.504 73.1073L149.479 73.2079L149.353 73.1576L149.328 73.2582L149.226 73.2079L149.101 73.2834L149.126 73.3597L149.025 73.3094V73.4101L148.95 73.3849L148.899 73.4855L148.874 77.0398C148.531 76.7975 148.27 76.4695 148.092 76.0561L147.992 75.7038L147.941 75.1495L147.992 74.8215L147.664 74.7209L147.588 74.7461C147.672 74.6957 147.655 74.6446 147.538 74.5943L147.135 73.6365L145.774 71.0659C144.906 69.6134 143.957 68.2782 142.925 67.0579Z",
    fill: "#ED2E8C"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M178.365 67.5116L179.978 67.8144H180.281L180.936 67.9654H181.239L182.196 68.1666L182.801 68.217L182.928 68.2681L183.382 69.8054L184.137 72.9815L184.011 73.0066L183.356 72.8557H183.054L183.003 72.8045L179.701 72.3005L178.995 69.553L178.365 67.5116Z",
    fill: "#ED2E8C"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M181.037 73.6616L181.011 73.7371L180.986 76.737C180.566 76.4007 180.356 75.8547 180.356 75.0982C180.434 75.058 180.45 74.9573 180.407 74.7963L180.382 74.7208C180.469 74.7477 180.494 74.7057 180.457 74.5942L180.709 74.0398L180.86 73.8889L180.835 73.8134C180.879 73.8905 180.921 73.8821 180.961 73.7882L181.037 73.6616Z",
    fill: "#ED2E8C"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M111.266 88.2814H137.682L137.757 88.3569L138.665 89.5671C138.753 89.614 138.787 89.7147 138.766 89.8698L136.598 95.7422L106.855 95.7171L108.922 90.0711L109.149 89.6929L111.266 88.2814Z",
    fill: "#ED2E8C"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9559 88.4324H73.2549L73.3304 88.5087L73.9862 89.5168L73.9862 89.6178L65.9702 112.857L65.6682 113.714L65.441 113.942L64.0798 114.95H39.8823L39.0503 113.765L46.6622 91.684L46.7636 91.533L47.1662 90.2221L47.4941 89.4919L48.9559 88.4324ZM53.3674 95.692L52.5103 96.2967L52.2587 96.5994L52.0062 97.3056L48.7295 106.883L49.3342 107.69H59.6692L60.6773 106.985L60.7779 106.833L61.131 105.825L61.6351 104.212L61.7357 104.06L62.2397 102.448L64.3071 96.5491L63.954 95.8429L63.8534 95.692H53.3674Z",
    fill: "#ED2E8C"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2036 88.4324H103.402L103.528 88.559L104.082 89.4162L104.132 89.6678L102.873 93.1969L102.469 94.5329L100.881 95.692H83.4885L82.5055 96.4736L82.3042 97.0783V97.3307L82.7831 98.0612L100.074 98.0612L100.201 98.1879L100.856 99.0953V99.2463L97.9321 107.615L97.4784 109.076L97.3778 109.228L96.924 110.69L96.8225 110.841L95.8648 113.79L94.2269 114.95H70.0788L69.298 113.866V113.664L70.9108 109.076L71.0869 108.749L72.5496 107.69H89.8909L90.9753 106.858L91.1766 106.052L90.7732 105.371H72.5496L72.4733 105.296L72.3223 105.043V104.842L77.5146 89.8187L77.6915 89.4916L79.2036 88.4324Z",
    fill: "#ED2E8C"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M144.689 88.4324H168.938L169.013 88.5087L169.669 89.5168L169.669 89.6178L168.005 94.4566L167.779 94.6839L166.418 95.692H149.025L148.042 96.4738L147.79 97.2804L148.319 98.0612L165.611 98.0612L165.737 98.1879L166.392 99.0953V99.1964L161.653 113.009L161.402 113.714L161.225 113.891L159.763 114.95H135.616L134.784 113.765L136.346 109.329L136.624 108.749L138.085 107.69H155.377L156.461 106.909L156.713 106.052L156.31 105.371H138.085L138.01 105.296L137.808 104.943L142.849 90.3739L143.227 89.4916L144.689 88.4324Z",
    fill: "#ED2E8C"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M174.836 88.4324H199.135L199.16 88.5087L199.866 89.5671L198.203 94.4063L198.076 94.5833L196.564 95.692L188.851 95.692L187.817 96.3981L182.373 112.353L182.272 112.505L181.919 113.664L181.793 113.841L180.231 114.95H175.315L174.66 113.916L174.609 113.714L180.609 96.4736L180.079 95.692L171.509 95.692L171.484 95.6165L171.332 95.3137L173.198 89.8699C173.249 89.651 173.358 89.4916 173.525 89.3902L174.836 88.4324Z",
    fill: "#ED2E8C"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M105.998 98.0109L135.716 98.0109L135.741 98.0864L133.069 105.321L103.326 105.296L105.998 98.0109Z",
    fill: "#ED2E8C"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M102.469 107.589H132.187L132.212 107.665L130.02 113.488L127.852 114.95H101.435L100.452 113.664C100.365 113.617 100.332 113.516 100.352 113.362L102.469 107.589Z",
    fill: "#ED2E8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogo);
export default __webpack_public_path__ + "static/media/full-logo.ff29c0dffee66ec3292f917f35ab012a.svg";
export { ForwardRef as ReactComponent };